import 'prosemirror-state';
import 'prosemirror-model';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = ".pk-view-container .ct-link{color:#1890ff;background:transparent;text-decoration:none;outline:none;cursor:pointer}.pk-view-container .ct-link:hover{text-decoration:underline}";
styleInject(css_248z);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var linkRender = function linkRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _this = this;
    _classCallCheck(this, linkRender);
    this.containerRender = function($container) {
        var nodes = $container.querySelectorAll("a");
        nodes.forEach(function(node) {
            var _this_config_provider;
            var href = node.getAttribute("href");
            if (!href) return;
            if (_this.config.openInNewTab) {
                node.setAttribute("target", "_blank");
            }
            var autoUpdate = node.getAttribute("data-auto_update") === "1";
            if (autoUpdate && ((_this_config_provider = _this.config.provider) === null || _this_config_provider === void 0 ? void 0 : _this_config_provider.getLinkTitle)) {
                _this.config.provider.getLinkTitle(node.getAttribute("href")).then(function(title) {
                    node.classList.add("ct-link-auto-update");
                    node.innerText = title;
                }).catch(function(e) {
                    console.error(e);
                });
            }
        });
    };
    this.fragmentCls = ".".concat(classNamePrefix("link"));
    this.config = config;
};

export default linkRender;
//# sourceMappingURL=render.js.map
